import React from 'react';
import ModalComponent from '@ui/components/Modal/Modal.component';
import ButtonComponent from '@ui/components/Button/Button.component';
import ButtonBarComponent from '@ui/components/Button-bar/Button-bar.component';
import { IProps } from './IProps';

const Component: React.FC<IProps> = ({
    alert,
    alertText,
    className,
    loading,
    lang,
    title,
    text,
    onConfirmClick,
    onCancelClick,
    onBtnKeyDown,
}: IProps) => {
    return (
        <ModalComponent
            alert={alert}
            alertText={alertText}
            className={className}
            loading={loading}
            title={title}
            text={text}
            lang={lang}
            onBtnKeyDown={onBtnKeyDown}
            onClose={onCancelClick}
        >
            <ButtonBarComponent>
                <ButtonComponent
                    label="yes"
                    lang={lang}
                    onClick={onConfirmClick}
                    onKeyDown={onBtnKeyDown}
                />
                <ButtonComponent
                    color="error"
                    label="no"
                    lang={lang}
                    onClick={onCancelClick}
                    onKeyDown={onBtnKeyDown}
                />
            </ButtonBarComponent>
        </ModalComponent>
    );
};

const DialogComponent = React.memo(Component);

export default DialogComponent;
